(function (global, $, jcf, Si) {
    "use strict";

    Si.when('Ajax/League', 'Templates', 'Helpers', 'TableSorter').then(leaguePage);

    function leaguePage(League, Templates, Helpers, TableSorter) {
        console.log('I work');
        var tour_id = $('input[name="tour_id"]').val();
        var controls = {},
            params = {tour_id: tour_id},
            changeHandlers = {
                "season": seasonChangeHandler,
                "homeaway": homeawayChangeHandler,
                "lastgames": lastgamesChangeHandler,
            };
        var $loader = $('[data-loader]');
        var $viewsHolder = $('#partial-league-grid');
        init();

        //init page, handlers and custom form elements
        function init() {
            var $viewsHolder = $('[data-view]');
            jcf.setOptions(
                'Select', {
                    wrapNative: false,
                    wrapNativeOnMobile: true
                }
            );
            jcf.replaceAll();

            $('.compare-checkbox').each(function () {
                $(this).on('click', function (e) {
                    if ($('.compare-checkbox:checked').length > 2)
                        e.preventDefault();
                });
            });

            //redirect to h2h page
            $('.btn-compare').on('click', function(e){
                e.preventDefault();
                if ($('.compare-checkbox:checked').length < 2){
                    alert('Please select 2 teams to compare!');
                    return false;
                }


                var i = 1;
                $('.compare-checkbox:checked').each(function(){
                    params['team'+i] = $(this).val();
                    i++;
                });

                var url = encodeQueryData(params);
                window.open("h2h?"+url, '_blank');
            });

            TableSorter.forTable($viewsHolder.find('.league-table'));

            controls['all'] = $('[data-control]');
            controls['all'].each(
                function () {
                    var $ctrl = $(this),
                        name = $ctrl.data('control');
                    controls[$ctrl.data('control')] = $ctrl;
                    if ($ctrl.is('select')) {
                        $ctrl.data('lastValue', $ctrl.val());
                        $ctrl.on('change', getSelectChangeHandler(name));
                    } else {
                        $ctrl.on('click', changeHandlers[name]);
                    }
                }
            );
            //predefined default selections
            loadData($('[data-control="season"]').first());
            loadData($('[data-control="homeaway"]').first());
            loadData($('[data-control="lastgames"]').first());
        }

        function encodeQueryData(data) {
            var ret = [];
            for (var d in data)
                ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
            return ret.join('&');
        }

        function getSelectChangeHandler(name) {

            return function (event) {
                // check if value really changed
                var $ctrl = $(this),
                    newVal = $ctrl.val(),
                    lastVal = $ctrl.data('lastValue');
                if (newVal != lastVal) {
                    $ctrl.data('lastValue', newVal);
                    return changeHandlers[name].call(this, event);
                }
            };
        }

        //handlers
        function seasonChangeHandler(event) {
            event.preventDefault();
            $('[data-control="season"]').removeClass('active');
            $(event.target).addClass('active');
            loadData(event.target);
            getData();
        }

        function homeawayChangeHandler(event) {
            event.preventDefault();
            $('[data-control="homeaway"]').removeClass('active');
            $(event.target).addClass('active');
            loadData(event.target);
            getData();
        }

        function lastgamesChangeHandler(event) {
            loadData(event.target);
            getData();
        }


        function getData() {
            $loader.addClass('visible');
            return League.get(params).then(
                function (response) {
                    renderView(response);
                    $loader.removeClass('visible');
                }, function (status, error) {

                    console.log(status, error);
                    alert('Error appear while data loading...');
                    $loader.removeClass('visible');
                }
            );
        }

        function loadData(target) {
            params = fillLoadParams(
                target,
                params
            );
        }

        function fillLoadParams(target, params) {
            if ($(target).is('select')) {
                params['lastgames'] = controls.lastgames.val();
            } else {
                switch ($(target).data('control')) {
                    case 'season':
                        params['season'] = $(target).html();
                        break;
                    case 'homeaway':
                        params['homeaway'] = $(target).html();
                        break;
                    default:
                        throw new Error("Unknown control trigger data loading!");
                        break;
                }
            }

            return params;
        }

        function renderView(data) {
            var content = Templates.make('league-grid.mustache', data);
            $viewsHolder.empty();
            $viewsHolder.append(content);
            TableSorter.forTable($viewsHolder.find('.league-table'));
            $loader.removeClass('visible');
        }


    }


})(window, jQuery, jcf, Si);
